module.exports = __webpack_public_path__ + "img/per_photo@2x.c63c734d.png";